<template>
  <div class="demo-fullWrapper">
    <div class="demo-headerWrapper">
      <img src="/assets/readerLogo.svg" alt="readerLogo" class="demo-headerLogo" />
      <div class="demo-defualtText">{{ $t('demoSynthesize.defualtText') }}</div>
    </div>
    <div class="demo-wrapper">
      <div class="demo-stepsWrapper">
        <div class="demo-stepItemWrapper" :class="item.focus ? 'demo-stepFocusWrapper' : ''"
          v-for="(item, index) in steps" :key="index">
          <div class="demo-step" :class="item.focus ? 'demo-stepNoFocus' : ''">
            {{ item.number }}
          </div>
          <div class="demo-stepText" :class="item.focus ? 'demo-stepTextFocus' : ''">
            {{ $t(item.text) }}
          </div>
        </div>
      </div>
      <div class="demo-chooseWrapper">
        <div v-if="step == 1" class="demo-configWrapper">
          <textarea type="text" autocomplete="off" :placeholder="$t('demoSynthesize.placeholder')" name="demoInput"
            v-model="demoText" />
          <div class="demo-characterCountWrapper">
            <div style="margin-right: 4px" :class="[
  demoText.length > availableCount ? 'demo-characterWarning' : '',
]">
              {{ demoText.length }}
            </div>
            /
            <div style="margin-left: 4px">{{ availableCount }}</div>
            <div v-if="inputError == true" class="demo-warningInfo">
              {{ this.inputText }}
            </div>
          </div>
        </div>
        <div v-else-if="step == 2" class="demo-configWrapperStep2">
          <v-radio-group v-model="voiceId">
            <v-radio v-for="(n, index) in voice" :key="index" class="demo-checkboxLabel d-flex flex flex-wrap"
              color="#787ff7" :label="$t(n.people)" :value="n.value" :disabled=n.disabled>
              <template slot="label">
                <span :class="n.disabled ? 'disabled-voice' : ''">{{ $t(n.people) }}</span>
              </template>
            </v-radio>
          </v-radio-group>
          <v-radio-group v-model="voiceId">
            <v-radio v-for="(n, index) in voice2" :key="index" class="demo-checkboxLabel d-flex flex flex-wrap"
              color="#787ff7" :label="$t(n.people)" :value="n.value" :disabled=n.disabled>
              <template slot="label">
                <span :class="n.disabled ? 'disabled-voice' : ''">{{ $t(n.people) }}</span>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
        <div v-else-if="step == 3" class="demo-configWrapper">
          <v-radio-group v-model="speed">
            <v-radio v-for="(n, index) in speeds" :key="index" class="demo-checkboxLabel" color="#787ff7"
              :label="$t(n.title)" :value="n.value"></v-radio>
          </v-radio-group>
        </div>
        <div v-else-if="step == 4" class="demo-configWrapperStep2">
          <v-radio-group >
            <v-radio v-for="(n, index) in background1" :key="index" class="demo-checkboxLabel d-flex flex flex-wrap"
              color="#787ff7" :label="$t(n.background)" :disabled=true>
              <template slot="label">
                <span :class="true ? 'disabled-voice' : ''">{{ $t(n.background) }}</span>
              </template>
            </v-radio>
          </v-radio-group>
          <v-radio-group >
            <v-radio v-for="(n, index) in background2" :key="index" class="demo-checkboxLabel d-flex flex flex-wrap"
              color="#787ff7" :label="$t(n.background)" :disabled=true>
              <template slot="label">
                <span :class="true ? 'disabled-voice' : ''">{{ $t(n.background) }}</span>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
        <div v-else-if="step == 5" class="demo-configWrapper">
          <div id="audio" class="audio">
            <AudioPlayer :file="blobUrl" :autoPlay="false"></AudioPlayer>
          </div>
        </div>
        <div class="demo-actionWrapper">
          <v-btn v-if="step == 2 || step == 3 || step == 4" class="demo-backButton" @click="goBack">{{
    $t('demoSynthesize.backButton')
}}</v-btn>
          <v-btn class="demo-nextButton" @click="nextStep" v-if="step == 1 || step == 2 || step == 3">{{
    $t('demoSynthesize.nextButton')
}}
            <div style="height: 14px; margin-left: 14px">
              <RightArrowIcon />
            </div>
          </v-btn>
          <v-btn class="demo-nextButton" @click="textSynthesize" v-if="this.step == 4" :loading="convertLoading">{{
    $t('demoSynthesize.convertBtn')
}}
            <div style="height: 14px; margin-left: 14px">
              <RightArrowIcon />
            </div>
          </v-btn>
          <v-btn v-if="step == 5" class="demo-backButton" @click="clearState">{{ $t('demoSynthesize.clearStateBtn')
}}</v-btn>
          <a href="https://auth.bolor.net/signup" style="text-decoration: none">
            <v-btn class="demo-nextButton" v-if="this.step == 5">{{ $t('demoSynthesize.login') }}
              <div style="height: 14px; margin-left: 14px">
                <RightArrowIcon />
              </div>
            </v-btn>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RightArrowIcon from "../components/icons/RightArrowIcon";
import AudioPlayer from "../components/AudioPlayer";
import { mapActions } from "vuex";
export default {
  name: "DemoSynthesize",
  components: {
    RightArrowIcon,
    AudioPlayer,
  },
  data: () => ({
    step: 1,
    steps: [
      { number: 1, focus: true, text: "demoSynthesize.step1" },
      { number: 2, focus: false, text: "demoSynthesize.step2" },
      { number: 3, focus: false, text: "demoSynthesize.step3" },
      { number: 4, focus: false, text: "demoSynthesize.step4" },
      { number: 5, focus: false, text: "demoSynthesize.step5" },
    ],
    demoText: "",
    availableCount: 200,
    voice: [
      { people: "demoSynthesize.femaleVoice1", value: 1, disabled: false },
      { people: "demoSynthesize.maleVoice2", value: 2, disabled: false },
      { people: "demoSynthesize.femaleVoice2", value: 3, disabled: true },
      { people: "demoSynthesize.femaleVoice3", value: 3, disabled: true },
    ],
    voice2: [
      { people: "demoSynthesize.femaleVoice4", value: 3, disabled: true },
      { people: "demoSynthesize.maleVoice3", value: 3, disabled: true },
      { people: "demoSynthesize.maleVoice1", value: 3, disabled: true },
      { people: "demoSynthesize.maleVoice4", value: 3, disabled: true },
    ],
    background1: [
      { background: "demoSynthesize.background1" },
      { background: "demoSynthesize.background2" },
      { background: "demoSynthesize.background3" },
      { background: "demoSynthesize.background4" },
      { background: "demoSynthesize.background5" },
    ],
    background2: [
      { background: "demoSynthesize.background6" },
      { background: "demoSynthesize.background7" },
      { background: "demoSynthesize.background8" },
      { background: "demoSynthesize.background9" },
      { background: "demoSynthesize.background10" },
    ],
    speeds: [
      { value: 0.75, title: "demoSynthesize.speedValue1" },
      { value: 1, title: "demoSynthesize.speedValue2" },
      { value: 1.25, title: "demoSynthesize.speedValue3" },
    ],
    voiceId: 1,
    speed: 1,
    inputError: true,
    inputText: "",
    audio_path:
      "audio/3/62323362373466322d623162342d343730662d396664612d336432313335656563333837.wav",
    convertLoading: false,
    blobUrl: "null",
  }),
  watch: {
    demoText: function () {
      this.inputValidate();
    },
  },
  methods: {
    ...mapActions(["showErrorMessage", "checkError"]),
    goBack() {
      this.step--;
      this.focused();
    },
    nextStep() {
      if (this.step != 1) {
        this.step++;
      } else if (this.inputValidate()) {
        this.step++;
      }
      this.focused();
    },
    textSynthesize() {
      this.convertLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_BASE_URL}/v2/demo?voiceID=${this.voiceId}&speed=${this.speed}`,
          this.demoText
        )
        .then((res) => {
          if (res.status == 200) {
            this.blobUrl = "data:audio/wav;base64," + res.data.data;
            this.convertLoading = false;
            this.nextStep();
          }
        })
        .catch((error) => {
          console.log(error);
          this.convertLoading = false;
          this.clearState();
          this.checkError(error);
        });
    },
    focused() {
      this.steps.map((item, index) => {
        if (item.number == this.step) {
          this.steps[index].focus = true;
        } else {
          this.steps[index].focus = false;
        }
      });
    },
    inputValidate() {
      if (this.demoText.length == 0) {
        this.inputError = true;
        this.inputText = this.$t('demoSynthesize.validate1');
        return false;
      } else if (this.demoText.length > 200) {
        this.inputError = true;
        this.inputText = this.$t('demoSynthesize.validate2');
        return false;
      } else {
        this.inputError = false;
        this.inputText = "";
        return true;
      }
    },
    clearState() {
      this.demoText = "";
      this.voiceId = 2;
      this.speed = 1;
      this.step = 1;
      this.focused();
    },
  },
};
</script>

<style>
.demo-fullWrapper {
  display: flex;
  flex-direction: column;
  max-width: 948px;
  width: 100%;
  padding: 30px;
  border-radius: 9px;
  border: 2px solid #e9e9e9;
  background-color: #ffffff;
  position: relative;
}

.demo-headerWrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.demo-headerLogo {
  width: 103px;
  height: 35px;
  margin-right: 20px;
  margin-bottom: 10px;
}

.demo-defualtText {
  font-size: 16px;
  line-height: 24px;
  color: #767676;
}

.demo-wrapper {
  display: flex;
  width: 100%;
}

.demo-stepsWrapper {
  display: flex;
  flex-direction: column;
  padding-right: 20px;
  width: 48%;
}
.audio {
  width: 100% !important;
}
.demo-chooseWrapper {
  display: flex;
  flex-direction: column;
  width: 52%;
  background-color: #ffffff;
  border: 2px solid #e9e9e9;
  border-radius: 9px;
  height: auto;
  padding: 16px;
}

.demo-stepItemWrapper {
  display: flex;
  align-items: center;
  width: 100%;
  height: 41px;
  background-color: #ffffff;
  border-radius: 9px;
  padding: 0 10px;
  margin-bottom: 6px;
}

.demo-stepFocusWrapper {
  background-color: #f3f1f7 !important;
}

.demo-step {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  min-height: 26px;
  max-width: 26px;
  min-height: 26px;
  border-radius: 50%;
  background-color: #e2e4ff;
  font-size: 16px;
  line-height: 24px;
  color: #777ff6;
  font-weight: 700;
}

.demo-stepNoFocus {
  background-color: #ffffff !important;
}

.demo-stepText {
  font-size: 16px;
  line-height: 24px;
  color: #767676;
  margin-left: 10px;
}

.demo-stepTextFocus {
  color: #1f2d3d;
  font-weight: 500;
}

.disabled-voice {
  color: gray !important;
}

.demo-configWrapper {
  display: flex;
  position: relative;
  height: 140px;
  padding: 8px;
}

.demo-configWrapperStep2 {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  height: 140px;
  padding: 8px;
  justify-content: space-around;
}

.demo-configWrapper textarea {
  font-size: 14px;
  line-height: 16px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  color: #1f2d3d;
  resize: none;
}

.demo-configWrapper textarea:focus {
  outline: none;
}

.demo-configWrapper textarea:hover {
  outline: none;
}

.demo-characterCountWrapper {
  display: flex;
  align-items: center;
  position: absolute;
  font-size: 14px;
  color: #767676;
  bottom: -40px;
  left: 10px;
}

.demo-characterWarning {
  color: red;
}

.demo-warningInfo {
  color: red;
  font-size: 12px;
  margin-left: 10px;
}

.demo-actionWrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-top: 40px;
}

.demo-nextButton {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #777ff6 !important;
  border: 2px solid #777ff6;
  border-radius: 8px;
  box-shadow: none !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin: 10px 0 0 20px;
  height: 45px !important;
  width: 192px;
  letter-spacing: 0;
}

.demo-backButton {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  box-shadow: none !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  outline: none;
  margin: 10px 0 0 20px;
  height: 30px !important;
  width: auto;
  letter-spacing: 0;
}

.demo-checkboxLabel label {
  color: #1f2d3d !important;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
}

.demo-voiceWrapper .v-input--selection-controls,
.demo-speedWrapper .v-input--selection-controls {
  margin-top: 0;
  padding-top: 4px !important;
}

@media screen and (max-width: 768px) {
  .demo-wrapper {
    flex-direction: column;
  }

  .demo-stepsWrapper {
    width: 100%;
    margin-bottom: 20px;
  }

  .demo-chooseWrapper {
    width: 100%;
  }
}
</style>
